import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { STAR_EMPTY_COLOR, STAR_FILL_COLOR } from '../../constants/index';
import { StarRateSvgIcon } from '../Common/Assets/SvgIconComponent/CommonSvgIcon';

const StarRating = (props) => {

  const [rating, setRating] = useState(0);

  const onStarClick = (nextValue, prevValue, name) => {
    const { change } = props;
    setRating(nextValue);
    change(nextValue);
  }

  const { className, name, editing, value, starCount } = props;
  return (
    <div className={className}>
      {Array.from({ length: starCount ? starCount : 1 }, (elem, index) => {
        return (
          <React.Fragment key={index}>
            <StarRateSvgIcon
              color={(editing ? rating : value) > index ? STAR_FILL_COLOR : (starCount ? STAR_EMPTY_COLOR : STAR_FILL_COLOR)}
              onClick={() => editing ? onStarClick(index + 1) : null}
            />
          </React.Fragment>
        )
      })}
    </div>
  );
}

StarRating.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.string,
  change: PropTypes.any,
  editing: PropTypes.bool,
  value: PropTypes.number
};

StarRating.defaultProps = {
  editing: false,
  value: 0
};

export default StarRating;